import { ApiState } from "@/store/general.types";
import { CitationDuplicateStatus } from "../duplicate-citation/duplicate-citation.types";

export interface CitationState {
    getUser: ApiState<UserDetail>;
}

export interface GetUserPayload {
    userId: number;
}

export interface GetDuplicateCitationPayLoad {
    projectId: number;
    page: number;
    perPage: number;
    search: string;
}

export interface UserDetail {
    name: string;
}

export interface MarkCitationAsDuplicatePayload {
    projectId: number;
    citationIds: number[];
    status: CitationDuplicateStatus;
    stage: ManualDuplicateStage;
}

export enum ManualDuplicateStage {
    AWAITING_SCREENING = 'AWAITING_SCREENING',
    POSSIBLE_DUPLICATES = 'POSSIBLE_DUPLICATES'
}

export interface MarkCitationAsDuplicateResult {
    markedCitationIds: number[];
    screenedCitationIds: number[];
}

export interface DuplicateUndoStackDetailsPayLoad {
    projectId: number;
    screen: DuplicationUndoScreen;
}

export enum DuplicationUndoScreen {
    REMOVED_DUPLICATE = 'REMOVED_DUPLICATE',
    MANUALLY_REMOVED_DUPLICATE = 'MANUALLY_REMOVED_DUPLICATE',
    PARTIAL_DUPLICATE = 'PARTIAL_DUPLICATE'
}

export enum CitationField {
    TITLE = 'title',
    ABSTRACT = 'abstract',
    AUTHOR = 'author',
    TYPE = 'type',
    ACCESSED_DATE = 'accessedDate',
    CALL_NUMBER = 'callNumber',
    COLLECTION_EDITOR = 'collectionEditor',
    CONTAINER_TITLE = 'containerTitle',
    DOI = 'DOI',
    EDITION = 'edition',
    EDITOR = 'editor',
    EVENT = 'event',
    EVENT_PLACE = 'eventPlace',
    GENRE = 'genre',
    ISSUED = 'issued',
    ISSUE = 'issue',
    ISSUED_DATE = 'issuedDate',
    MEDIUM = 'medium',
    NOTE = 'note',
    NUMBER = 'number',
    NUMBER_OF_PAGES = 'numberOfPages',
    PAGE = 'page',
    PUBLISHER = 'publisher',
    PUBLISHER_PLACE = 'publisherPlace',
    PUBLICATION_YEAR = 'publicationYear',
    URL = 'url',
    VOLUME = 'volume'
}

export enum CitationLabel {
    TITLE = 'Title',
    ABSTRACT = 'Abstract',
    AUTHOR = 'Author',
    TYPE = 'Publication Type',
    ACCESSED_DATE = 'Accessed Date',
    CALL_NUMBER = 'Call Number',
    COLLECTION_EDITOR = 'Collection Editor',
    CONTAINER_TITLE = 'Container Title',
    DOI = 'DOI',
    EDITION = 'Edition',
    EDITOR = 'Editor',
    EVENT = 'Event',
    EVENT_PLACE = 'Event Place',
    GENRE = 'Genre',
    ISSUED = 'Issued',
    ISSUE = 'Issue',
    ISSUED_DATE = 'Issued Date',
    MEDIUM = 'Medium',
    NOTE = 'Note',
    NUMBER = 'Number',
    NUMBER_OF_PAGES = 'Number Of Pages',
    PAGE = 'Page',
    PUBLISHER = 'Publisher',
    PUBLISHER_PLACE = 'Publisher Place',
    PUBLICATION_YEAR = 'Publication Year',
    URL = 'URL',
    VOLUME = 'Volume'
}